<template>
  
    <div class="actual_score_container">
        <div class="actual_score_left">
            <div class="actual_score_title">
                <h3 class="actual_first">{{ score_data.def_text.title }}</h3>
            </div>
            <div class="actual_progress_wrapper">

                <div class="actual_progress_back">
                    <div class="actual_progress_container">
                        <div class="actual_progress_active_container">
                            <div class="actual_progress_active" :style="{width: bar_width }">
                                <span class="score_bar">{{ bar_width }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
 
        <div class="actual_score_right">
            <div class="actual_score_def">
                <p class="actual_score_punchline">{{ score_data.def_text.subtitle }}</p>
                <p><strong>Rôle : </strong>{{ score_data.def_text.role }}</p>
                <p><strong>Description : </strong>{{ score_data.def_text.description }}</p>
            </div>
        </div>
    </div>

</template>

<script>


export default {
    name: 'UltimScore2',
    props: ['score_data'],
    components: {
        
    },
    mounted() {},
    data(){
        return {}
    },
    computed: {
        bar_width(){
            let score = this.score_data.score * 100 / 5
            return score + '%'
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
    .actual_score_container{
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        .actual_score_left{

        }
        .actual_score_right{
            padding-left: 20px;
        }
        .actual_score_title{
            text-align: left;
            h3.actual_first{
                font-size: 1.6rem;
                font-weight: 500;
            }
            h3.actual_first::first-letter{
                color: #e40521;
                font-size: 130%;
                font-weight: 800;
        
            }
        }
        .actual_score_def{
            text-align: justify;
            font-size: 1.1rem;
            margin-top: 34px;
            line-height: 1.4rem;
            .actual_score_punchline{
                font-size: 1.3rem;
                line-height: 1.8rem;
            }
        }
        .actual_progress_wrapper{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 0 6px;
            .actual_progress_back{
                border-radius: 100px;
                    background: #d3d3d3;
                    width: 354px;
                    height: 43px;
                    padding: 1px;
                    box-shadow: 2px 5px 12px rgb(207, 207, 207);
                .actual_progress_container{
                    border-radius: 100px;
                    background: whitesmoke;
                    width: 350px;
                    height: 40px;
                    padding: 5px;
                }
                .actual_progress_active_container{
                    height: 100%;
                    border-radius: 100px;
                    background: #d9d9d9;
                    box-shadow: inset 0 0 10px #b5b5b5;
                    .actual_progress_active{
                        height: 100%;
                        border-radius: 100px;
                        background: #545352;                    
                        display: flex;
                        align-items: center;
                        padding-left: 18px;
                        .score_bar{
                            color: white;
                            font-weight: 600;
                        }
                
                    }
                }
            }
        }
    }

</style>
